import { BrowserRouter, Navigate, Outlet, Route } from 'react-router-dom'

import AIPersonaProposal from '@/pages/AIPersonaProposal'
import AIPurchaseAssistAbTests from '@/pages/AIPurchaseAssist/AbTests'
import AIPurchaseAssistAiProfiles from '@/pages/AIPurchaseAssist/AiProfiles'
import AIPurchaseAssistCampaigns from '@/pages/AIPurchaseAssist/Campaigns'
import AIPurchaseAssistConversations from '@/pages/AIPurchaseAssist/Conversations'
import AIPurchaseAssistDashboard from '@/pages/AIPurchaseAssist/Dashboard'
import AIPurchaseAssistFeedback from '@/pages/AIPurchaseAssist/Feedback'
import AIPurchaseAssistKnowledge from '@/pages/AIPurchaseAssist/Knowledge'
import AIPurchaseAssistNgRules from '@/pages/AIPurchaseAssist/NgRules'
import AIPurchaseAssistOpenings from '@/pages/AIPurchaseAssist/Openings'
import AIPurchaseAssistVectorSources from '@/pages/AIPurchaseAssist/VectorSources'
import AIPurchaseAssistProposal from '@/pages/AIPurchaseAssistProposal'

import { useAuthorizedMe } from '@/common/api/modules/auth'
import { dashboardPath, loginPath, siteDashboardPath } from '@/common/app/path'
import { MasterType } from '@/common/model/master/w2Master'
import { ChildProps } from '@/common/util/props'

import AppHeader from '@/components/container/layout/AppHeader'
import AppHeaderProvider from '@/components/container/layout/AppHeaderProvider'
import AppNavigation from '@/components/container/layout/AppNavigation'
import AppProvider from '@/components/container/layout/AppProvider'
import AnalyticsPage from '@/components/container/page/admin/analytics/AnalyticsPage'
import AuditLogPage from '@/components/container/page/admin/auditLog/AuditLogPage'
import BillingListPage from '@/components/container/page/admin/billing/BillingListPage'
import AdminDashboardPage from '@/components/container/page/admin/dashboard/AdminDashboard'
import FeatureListPage from '@/components/container/page/admin/featureList/FeatureListPage'
import LinkageApiKeyEditPage from '@/components/container/page/admin/linkageApiKey/LinkageApiKeyEditPage'
import LinkageApiKeyListPage from '@/components/container/page/admin/linkageApiKey/LinkageApiKeyListPage'
import LinkageApiKeyUpdatePage from '@/components/container/page/admin/linkageApiKey/LinkageApiKeyUpdatePage'
import OperatorEditPage from '@/components/container/page/admin/operator/OperatorEditPage'
import OperatorListPage from '@/components/container/page/admin/operator/OperatorListPage'
import OperatorUpdatePage from '@/components/container/page/admin/operator/OperatorUpdatePage'
import PersonaCatalogPage from '@/components/container/page/admin/persona/PersonaCatalogPage'
import PromotionKarteConfigPage from '@/components/container/page/admin/promotionKarteConfig/PromotionKarteConfigPage'
import SiteEditPage from '@/components/container/page/admin/site/SiteEditPage'
import SiteListPage from '@/components/container/page/admin/site/SiteListPage'
import SiteUpdatePage from '@/components/container/page/admin/site/SiteUpdatePage'
import SiteUsagePage from '@/components/container/page/admin/siteUsage/SiteUsagePage'
import SupportSpecPage from '@/components/container/page/admin/supportSpec/SupportSpecPage'
import SystemConfigEditPage from '@/components/container/page/admin/systemConfig/SystemConfigEditPage'
import W2CommerceLinkPage from '@/components/container/page/admin/w2CommerceLink/W2CommerceLinkPage'
import LoginPage from '@/components/container/page/login/LoginPage'
import SiteDashboardPage from '@/components/container/page/site/dashboard/SiteDashboardPage'
import ExternalArticlePage from '@/components/container/page/site/externalArticle/ExternalArticlePage'
import FileUploadPage from '@/components/container/page/site/master/FileUploadPage'
import MasterEditPage from '@/components/container/page/site/master/MasterEditPage'
import MasterListPage from '@/components/container/page/site/master/MasterListPage'
import MasterSummaryPage from '@/components/container/page/site/master/MasterSummaryPage'
import MasterUpdatePage from '@/components/container/page/site/master/MasterUpdatePage'
import MediaDashboardPage from '@/components/container/page/site/media/MediaDashboardPage'
import MediaGscLinkagePage from '@/components/container/page/site/media/MediaGscLinkagePage'
import MediaActionPage from '@/components/container/page/site/media/action/MediaActionPage'
import MediaAnalysisCannibalizationResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisCannibalizationResultPage'
import MediaAnalysisCitationResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisCitationResultPage'
import MediaAnalysisCompetitorResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisCompetitorResultPage'
import MediaAnalysisGapResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisGapResultPage'
import MediaAnalysisHistoryPage from '@/components/container/page/site/media/analysis/MediaAnalysisHistoryPage'
import MediaAnalysisLinkStructureResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisLinkStructureResultPage'
import MediaAnalysisPage from '@/components/container/page/site/media/analysis/MediaAnalysisPage'
import MediaAnalysisQueryFanoutResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisQueryFanoutResultPage'
import MediaAnalysisSentimentResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisSentimentResultPage'
import MediaAnalysisSerpResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisSerpResultPage'
import MediaAnalysisShareOfVoiceResultPage from '@/components/container/page/site/media/analysis/MediaAnalysisShareOfVoiceResultPage'
import MediaAnalysisAutomationPage from '@/components/container/page/site/media/analysisAutomation/MediaAnalysisAutomationPage'
import AnalysisTargetEditPage from '@/components/container/page/site/media/analysisTarget/AnalysisTargetEditPage'
import AnalysisTargetListPage from '@/components/container/page/site/media/analysisTarget/AnalysisTargetListPage'
import MediaAiTrainingDataArticleHtmlPage from '@/components/container/page/site/media/aiTrainingData/MediaAiTrainingDataArticleHtmlPage'
import MediaAiTrainingDataCommonRulesPage from '@/components/container/page/site/media/aiTrainingData/MediaAiTrainingDataCommonRulesPage'
import MediaAiTrainingDataPage from '@/components/container/page/site/media/aiTrainingData/MediaAiTrainingDataPage'
import AnalysisTargetUpdatePage from '@/components/container/page/site/media/analysisTarget/AnalysisTargetUpdatePage'
import ArticleAnalysisListPage from '@/components/container/page/site/media/article/ArticleAnalysisListPage'
import ArticleApprovalDetailPage from '@/components/container/page/site/media/article/ArticleApprovalDetailPage'
import ArticleApprovalListPage from '@/components/container/page/site/media/article/ArticleApprovalListPage'
import ArticleDetailPage from '@/components/container/page/site/media/article/ArticleDetailPage'
import ArticleEditPage from '@/components/container/page/site/media/article/ArticleEditPage'
import ArticleListPage from '@/components/container/page/site/media/article/ArticleListPage'
import ArticleUpdatePage from '@/components/container/page/site/media/article/ArticleUpdatePage'
import PersonaAssignmentPage from '@/components/container/page/site/persona/PersonaAssignmentPage'
import PersonaHealthPage from '@/components/container/page/site/persona/PersonaHealthPage'
import PersonaLibraryPage from '@/components/container/page/site/persona/PersonaLibraryPage'
import PersonaTrendPage from '@/components/container/page/site/persona/PersonaTrendPage'
import ProductInfoUsagePage from '@/components/container/page/site/productInfoUsage/ProductInfoUsagePage'
import ProductUnderstandingPage from '@/components/container/page/site/productUnderstanding/ProductUnderstandingPage'
import PromotionOutboxListPage from '@/components/container/page/site/promotionOutbox/PromotionOutboxListPage'
import AITagListPage from '@/components/container/page/site/recommend/AITagListPage'
import AccessCustomerListPage from '@/components/container/page/site/recommend/AccessCustomerListPage'
import BehaviorListPage from '@/components/container/page/site/recommend/BehaviorListPage'
import DeliveryStatsPage from '@/components/container/page/site/recommend/DeliveryStatsPage'
import ModelTuningPage from '@/components/container/page/site/recommend/ModelTuningPage'
import OrderHistoryPage from '@/components/container/page/site/recommend/OrderHistoryPage'
import SetupGuidePage from '@/components/container/page/site/recommend/SetupGuidePage'
import TagEditPage from '@/components/container/page/site/recommend/TagEditPage'
import TagManagerPage from '@/components/container/page/site/recommend/TagManagerPage'
import TagUpdatePage from '@/components/container/page/site/recommend/TagUpdatePage'
import RecommendationDistributionAbCampaignPage from '@/components/container/page/site/recommend/distribution/RecommendationDistributionAbCampaignPage'
import RecommendationDistributionEditPage from '@/components/container/page/site/recommend/distribution/RecommendationDistributionEditPage'
import RecommendationDistributionListPage from '@/components/container/page/site/recommend/distribution/RecommendationDistributionListPage'
import RecommendationDistributionUpdatePage from '@/components/container/page/site/recommend/distribution/RecommendationDistributionUpdatePage'
import WidgetEditPage from '@/components/container/page/site/recommend/widget/WidgetEditPage'
import WidgetListPage from '@/components/container/page/site/recommend/widget/WidgetListPage'
import WidgetUpdatePage from '@/components/container/page/site/recommend/widget/WidgetUpdatePage'
import WidgetPageEditPage from '@/components/container/page/site/recommend/widgetPage/WidgetPageEditPage'
import WidgetPageListPage from '@/components/container/page/site/recommend/widgetPage/WidgetPageListPage'
import WidgetPageUpdatePage from '@/components/container/page/site/recommend/widgetPage/WidgetPageUpdatePage'
import SearchSuggestAnalyticsPage from '@/components/container/page/site/searchSuggest/SearchSuggestAnalyticsPage'
import SearchSuggestDictionaryPage from '@/components/container/page/site/searchSuggest/SearchSuggestDictionaryPage'
import SearchSuggestSettingsPage from '@/components/container/page/site/searchSuggest/SearchSuggestSettingsPage'
import SearchTagCandidatesPage from '@/components/container/page/site/searchTag/SearchTagCandidatesPage'
import SearchTagDashboardPage from '@/components/container/page/site/searchTag/SearchTagDashboardPage'
import SearchTagDeliveryPage from '@/components/container/page/site/searchTag/SearchTagDeliveryPage'
import SearchTagListPage from '@/components/container/page/site/searchTag/SearchTagListPage'
import SearchTagOptimizationsPage from '@/components/container/page/site/searchTag/SearchTagOptimizationsPage'
import SearchTagSettingsPage from '@/components/container/page/site/searchTag/SearchTagSettingsPage'
import TargetListPage from '@/components/container/page/site/sendData/TargetListPage'
import W2SendStatusPage from '@/components/container/page/site/sendData/W2SendStatusPage'
import SiteOperatorEditPage from '@/components/container/page/site/setting/operator/SiteOperatorEditPage'
import SiteOperatorListPage from '@/components/container/page/site/setting/operator/SiteOperatorListPage'
import SiteOperatorUpdatePage from '@/components/container/page/site/setting/operator/SiteOperatorUpdatePage'
import PermissionTemplateEditPage from '@/components/container/page/site/setting/permission/PermissionTemplateEditPage'
import PermissionTemplateListPage from '@/components/container/page/site/setting/permission/PermissionTemplateListPage'
import PermissionTemplateUpdatePage from '@/components/container/page/site/setting/permission/PermissionTemplateUpdatePage'
import UGCDeletionRequestPage from '@/components/container/page/site/ugc/UGCDeletionRequestPage'
import UGCFunnelDashboardPage from '@/components/container/page/site/ugc/UGCFunnelDashboardPage'
import UGCInstagramSettingsPage from '@/components/container/page/site/ugc/UGCInstagramSettingsPage'
import UGCMailPage from '@/components/container/page/site/ugc/UGCMailPage'
import W2ReviewSyncPage from '@/components/container/page/site/w2ReviewSync/W2ReviewSyncPage'

import { AuthProvider } from './AuthContext'
import AIPurchaseAssistRichUIDesigner from './pages/AIPurchaseAssist/RichUIDesigner'
import ContentProposal from './pages/ContentProposal'
import CustomerJourney from './pages/CustomerJourney'
import PasswordChange from './pages/PasswordChange'
import PermissionManagement from './pages/PermissionManagement'
import ProposalOverview from './pages/ProposalOverview'
import SiteOperatorManagement from './pages/SiteOperatorManagement'
import UGCAIScoreSettings from './pages/UGCAIScoreSettings'
import UGCCVRDashboard from './pages/UGCCVRDashboard'
import UGCDisplayRuleEdit from './pages/UGCDisplayRuleEdit'
import UGCDisplayRules from './pages/UGCDisplayRules'
import UGCGuide from './pages/UGCGuide'
import UGCInstagramCollection from './pages/UGCInstagramCollection'
import UGCProductTagging from './pages/UGCProductTagging'
import UGCReviewManagement from './pages/UGCReviewManagement'
import UGCSEODashboard from './pages/UGCSEODashboard'
import UGCTagEmbed from './pages/UGCTagEmbed'
import UGCVOCAnalysis from './pages/UGCVOCAnalysis'
import UGCWearDetection from './pages/UGCWearDetection'
import { SentryRoutes } from './sentry'

const TempPrePageMain = ({ children }: ChildProps) => {
  return <div className='ml-60 min-h-[calc(100vh-57px)] bg-slate-800 px-8 pt-20'>{children}</div>
}

const AppContent = () => {
  const { operatorMe, isLoading: isMeLoading, isAdmin } = useAuthorizedMe()
  if (!isMeLoading && !operatorMe) {
    return (
      <SentryRoutes>
        <Route path='/login' element={<LoginPage />} />
        <Route path='*' element={<Navigate to='/login' replace />} />
      </SentryRoutes>
    )
  }

  // if (isAdmin && !screenMode) {
  //   return (
  //     <SentryRoutes>
  //       <Route path='/select-mode' element={<ModeSelect />} />
  //       <Route path='*' element={<Navigate to='/select-mode' replace />} />
  //     </SentryRoutes>
  //   )
  // }

  const defaultRedirect = isAdmin
    ? dashboardPath()
    : operatorMe?.site_id
      ? siteDashboardPath(operatorMe?.site_id)
      : loginPath()

  return (
    <>
      <AppHeader isAdmin={isAdmin} />
      <SentryRoutes>
        {isAdmin && (
          <>
            <Route path='/' element={<Navigate to={defaultRedirect} replace />} />
            <Route
              path='/'
              element={
                <>
                  <AppNavigation />
                  <Outlet />
                </>
              }
            >
              <Route path='/dashboard' element={<AdminDashboardPage />} />
              <Route path='/analytics' element={<AnalyticsPage />} />
              <Route path='/sites' element={<SiteListPage />} />
              <Route path='/sites/new' element={<SiteEditPage />} />
              <Route path='/sites/:siteId' element={<SiteUpdatePage />} />
              <Route path='/operators' element={<OperatorListPage />} />
              <Route path='/operators/new' element={<OperatorEditPage />} />
              <Route path='/operators/:operatorId' element={<OperatorUpdatePage />} />
              <Route path='/system-config' element={<SystemConfigEditPage />} />
              <Route path='/w2-commerce-link' element={<W2CommerceLinkPage />} />
              <Route path='/promotion-karte-config' element={<PromotionKarteConfigPage />} />
              <Route path='/billing' element={<BillingListPage />} />
              <Route path='/audit-logs' element={<AuditLogPage />} />
              <Route path='/persona-catalog' element={<PersonaCatalogPage />} />
              <Route path='/linkage-api-keys' element={<LinkageApiKeyListPage />} />
              <Route path='/linkage-api-keys/new' element={<LinkageApiKeyEditPage />} />
              <Route
                path='/linkage-api-keys/:linkageApiKeyId/edit'
                element={<LinkageApiKeyUpdatePage />}
              />
              <Route path='/site-usage' element={<SiteUsagePage />} />
              <Route path='/support-spec' element={<SupportSpecPage />} />
              <Route path='/feature-list' element={<FeatureListPage />} />
              <Route
                path='/proposal'
                element={
                  <TempPrePageMain>
                    <ProposalOverview />
                  </TempPrePageMain>
                }
              />
              <Route
                path='/proposal2'
                element={
                  <TempPrePageMain>
                    <ContentProposal />
                  </TempPrePageMain>
                }
              />
              <Route
                path='/proposal3'
                element={
                  <TempPrePageMain>
                    <AIPurchaseAssistProposal />
                  </TempPrePageMain>
                }
              />
              <Route
                path='/proposal4'
                element={
                  <TempPrePageMain>
                    <AIPersonaProposal />
                  </TempPrePageMain>
                }
              />
            </Route>
          </>
        )}
        <Route
          path='/sites/:siteId'
          element={
            <>
              <AppNavigation />
              <Outlet />
            </>
          }
        >
          {/* Master */}
          <Route path='master-summary' element={<MasterSummaryPage />} />
          {/* API連携（W2 OpenAPI 送信） */}
          <Route path='w2-send-status' element={<W2SendStatusPage />} />
          <Route path='send-data/target-list' element={<TargetListPage />} />
          <Route path='send-data/promotion-outbox' element={<PromotionOutboxListPage />} />
          {/* 商品理解（データ理解＞商品理解。カバレッジ・分布/商品明細はページ内タブ） */}
          <Route path='product-understanding' element={<ProductUnderstandingPage />} />
          {/* 外部記事コンテンツ（データ基盤。記事一覧/取り込み設定はページ内タブ） */}
          <Route path='external-articles' element={<ExternalArticlePage />} />
          {/* W2レビュー連携（データ基盤。承認済みのW2レビューをUGCへ反映） */}
          <Route path='w2-review-sync' element={<W2ReviewSyncPage />} />
          <Route path='product-info-usage' element={<ProductInfoUsagePage />} />
          {/* AIペルソナ（データ基盤とAIレコメンドの間） */}
          <Route path='persona/library' element={<PersonaLibraryPage />} />
          <Route path='persona/assignment' element={<PersonaAssignmentPage />} />
          <Route path='persona/health' element={<PersonaHealthPage />} />
          <Route path='persona/trend' element={<PersonaTrendPage />} />
          {/* W2マスタ一覧/新規/編集 — base URL は w2MasterListPath / w2MasterNewPath / w2MasterEditPath と一致 */}
          <Route path='w2-users' element={<MasterListPage masterType={MasterType.W2_USER} />} />
          <Route path='w2-users/new' element={<MasterEditPage masterType={MasterType.W2_USER} />} />
          <Route
            path='w2-users/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER} />}
          />
          <Route
            path='w2-user-attributes'
            element={<MasterListPage masterType={MasterType.W2_USER_ATTRIBUTE} />}
          />
          <Route
            path='w2-user-attributes/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_ATTRIBUTE} />}
          />
          <Route
            path='w2-user-attributes/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_ATTRIBUTE} />}
          />
          <Route
            path='w2-member-ranks'
            element={<MasterListPage masterType={MasterType.W2_MEMBER_RANK} />}
          />
          <Route
            path='w2-member-ranks/new'
            element={<MasterEditPage masterType={MasterType.W2_MEMBER_RANK} />}
          />
          <Route
            path='w2-member-ranks/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MEMBER_RANK} />}
          />
          <Route
            path='w2-access-logs'
            element={<MasterListPage masterType={MasterType.W2_ACCESS_LOG} />}
          />
          <Route
            path='w2-access-logs/new'
            element={<MasterEditPage masterType={MasterType.W2_ACCESS_LOG} />}
          />
          <Route
            path='w2-access-logs/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ACCESS_LOG} />}
          />
          <Route
            path='w2-products'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT} />}
          />
          <Route
            path='w2-products/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT} />}
          />
          <Route
            path='w2-products/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT} />}
          />
          <Route
            path='w2-product-brands'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_BRAND} />}
          />
          <Route
            path='w2-product-brands/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_BRAND} />}
          />
          <Route
            path='w2-product-brands/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_BRAND} />}
          />
          <Route
            path='w2-product-categories'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_CATEGORY} />}
          />
          <Route
            path='w2-product-categories/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_CATEGORY} />}
          />
          <Route
            path='w2-product-categories/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_CATEGORY} />}
          />
          <Route
            path='w2-product-tags'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_TAG} />}
          />
          <Route
            path='w2-product-tags/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_TAG} />}
          />
          <Route
            path='w2-product-tags/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_TAG} />}
          />
          {/* 商品タグ設定マスター（add-w2-product-tag-setting）。編集は規約に従い <resource>/:id/edit */}
          <Route
            path='w2-product-tag-settings'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_TAG_SETTING} />}
          />
          <Route
            path='w2-product-tag-settings/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_TAG_SETTING} />}
          />
          <Route
            path='w2-product-tag-settings/:id/edit'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_TAG_SETTING} />}
          />
          <Route
            path='w2-product-inventory'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_STOCK} />}
          />
          <Route
            path='w2-product-inventory/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_STOCK} />}
          />
          <Route
            path='w2-product-inventory/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_STOCK} />}
          />
          <Route
            path='w2-product-variation'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_VARIATION} />}
          />
          <Route
            path='w2-product-variation/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_VARIATION} />}
          />
          <Route
            path='w2-product-variation/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_VARIATION} />}
          />
          <Route
            path='w2-product-price'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_PRICE} />}
          />
          <Route
            path='w2-product-price/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_PRICE} />}
          />
          <Route
            path='w2-product-price/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_PRICE} />}
          />
          <Route path='w2-cart' element={<MasterListPage masterType={MasterType.W2_CART} />} />
          <Route path='w2-cart/new' element={<MasterEditPage masterType={MasterType.W2_CART} />} />
          <Route
            path='w2-cart/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_CART} />}
          />
          <Route path='w2-orders' element={<MasterListPage masterType={MasterType.W2_ORDER} />} />
          <Route
            path='w2-orders/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER} />}
          />
          <Route
            path='w2-orders/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ORDER} />}
          />
          <Route
            path='w2-order-details'
            element={<MasterListPage masterType={MasterType.W2_ORDER_ITEM} />}
          />
          <Route
            path='w2-order-details/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER_ITEM} />}
          />
          <Route
            path='w2-order-details/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ORDER_ITEM} />}
          />
          <Route
            path='w2-order-coupons'
            element={<MasterListPage masterType={MasterType.W2_ORDER_COUPON} />}
          />
          <Route
            path='w2-order-coupons/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER_COUPON} />}
          />
          <Route
            path='w2-order-coupons/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ORDER_COUPON} />}
          />
          <Route path='w2-coupons' element={<MasterListPage masterType={MasterType.W2_COUPON} />} />
          <Route
            path='w2-coupons/new'
            element={<MasterEditPage masterType={MasterType.W2_COUPON} />}
          />
          <Route
            path='w2-coupons/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_COUPON} />}
          />
          <Route
            path='w2-advcodes'
            element={<MasterListPage masterType={MasterType.W2_ADV_CODE} />}
          />
          <Route
            path='w2-advcodes/new'
            element={<MasterEditPage masterType={MasterType.W2_ADV_CODE} />}
          />
          <Route
            path='w2-advcodes/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ADV_CODE} />}
          />
          <Route
            path='w2-features'
            element={<MasterListPage masterType={MasterType.W2_FEATURE_PAGE} />}
          />
          <Route
            path='w2-features/new'
            element={<MasterEditPage masterType={MasterType.W2_FEATURE_PAGE} />}
          />
          <Route
            path='w2-features/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FEATURE_PAGE} />}
          />
          <Route
            path='w2-feature-categories'
            element={<MasterListPage masterType={MasterType.W2_FEATURE_PAGE_CATEGORY} />}
          />
          <Route
            path='w2-feature-categories/new'
            element={<MasterEditPage masterType={MasterType.W2_FEATURE_PAGE_CATEGORY} />}
          />
          <Route
            path='w2-feature-categories/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FEATURE_PAGE_CATEGORY} />}
          />
          <Route
            path='w2-feature-contents'
            element={<MasterListPage masterType={MasterType.W2_FEATURE_PAGE_CONTENTS} />}
          />
          <Route
            path='w2-feature-contents/new'
            element={<MasterEditPage masterType={MasterType.W2_FEATURE_PAGE_CONTENTS} />}
          />
          <Route
            path='w2-feature-contents/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FEATURE_PAGE_CONTENTS} />}
          />
          <Route
            path='w2-product-groups'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_GROUP} />}
          />
          <Route
            path='w2-product-groups/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_GROUP} />}
          />
          <Route
            path='w2-product-groups/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_GROUP} />}
          />
          <Route
            path='w2-product-group-items'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_GROUP_ITEM} />}
          />
          <Route
            path='w2-product-group-items/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_GROUP_ITEM} />}
          />
          <Route
            path='w2-product-group-items/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_GROUP_ITEM} />}
          />
          <Route
            path='w2-contents-tags'
            element={<MasterListPage masterType={MasterType.W2_CONTENTS_TAG} />}
          />
          <Route
            path='w2-contents-tags/new'
            element={<MasterEditPage masterType={MasterType.W2_CONTENTS_TAG} />}
          />
          <Route
            path='w2-contents-tags/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_CONTENTS_TAG} />}
          />
          <Route
            path='w2-product-links'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_LINK} />}
          />
          <Route
            path='w2-product-links/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_LINK} />}
          />
          <Route
            path='w2-product-links/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_LINK} />}
          />
          {/* 拡張マスタ（add-w2-ex-product-spec で追加）。編集は規約に従い <resource>/:id/edit */}
          <Route
            path='w2-ex-product-specs'
            element={<MasterListPage masterType={MasterType.W2_EX_PRODUCT_SPEC} />}
          />
          <Route
            path='w2-ex-product-specs/new'
            element={<MasterEditPage masterType={MasterType.W2_EX_PRODUCT_SPEC} />}
          />
          <Route
            path='w2-ex-product-specs/:id/edit'
            element={<MasterUpdatePage masterType={MasterType.W2_EX_PRODUCT_SPEC} />}
          />
          <Route
            path='w2-ex-product-variation-specs'
            element={<MasterListPage masterType={MasterType.W2_EX_PRODUCT_VARIATION_SPEC} />}
          />
          <Route
            path='w2-ex-product-variation-specs/new'
            element={<MasterEditPage masterType={MasterType.W2_EX_PRODUCT_VARIATION_SPEC} />}
          />
          <Route
            path='w2-ex-product-variation-specs/:id/edit'
            element={<MasterUpdatePage masterType={MasterType.W2_EX_PRODUCT_VARIATION_SPEC} />}
          />
          {/* 施策系マスタ（add-w2-marketing-master-tables） */}
          <Route
            path='w2-user-point'
            element={<MasterListPage masterType={MasterType.W2_USER_POINT} />}
          />
          <Route
            path='w2-user-point/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_POINT} />}
          />
          <Route
            path='w2-user-point/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_POINT} />}
          />
          <Route
            path='w2-user-point-history'
            element={<MasterListPage masterType={MasterType.W2_USER_POINT_HISTORY} />}
          />
          <Route
            path='w2-user-point-history/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_POINT_HISTORY} />}
          />
          <Route
            path='w2-user-point-history/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_POINT_HISTORY} />}
          />
          <Route
            path='w2-point-rule'
            element={<MasterListPage masterType={MasterType.W2_POINT_RULE} />}
          />
          <Route
            path='w2-point-rule/new'
            element={<MasterEditPage masterType={MasterType.W2_POINT_RULE} />}
          />
          <Route
            path='w2-point-rule/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_POINT_RULE} />}
          />
          <Route
            path='w2-point-rule-schedule'
            element={<MasterListPage masterType={MasterType.W2_POINT_RULE_SCHEDULE} />}
          />
          <Route
            path='w2-point-rule-schedule/new'
            element={<MasterEditPage masterType={MasterType.W2_POINT_RULE_SCHEDULE} />}
          />
          <Route
            path='w2-point-rule-schedule/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_POINT_RULE_SCHEDULE} />}
          />
          <Route
            path='w2-user-member-rank-history'
            element={<MasterListPage masterType={MasterType.W2_USER_MEMBER_RANK_HISTORY} />}
          />
          <Route
            path='w2-user-member-rank-history/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_MEMBER_RANK_HISTORY} />}
          />
          <Route
            path='w2-user-member-rank-history/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_MEMBER_RANK_HISTORY} />}
          />
          <Route
            path='w2-member-rank-rule'
            element={<MasterListPage masterType={MasterType.W2_MEMBER_RANK_RULE} />}
          />
          <Route
            path='w2-member-rank-rule/new'
            element={<MasterEditPage masterType={MasterType.W2_MEMBER_RANK_RULE} />}
          />
          <Route
            path='w2-member-rank-rule/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MEMBER_RANK_RULE} />}
          />
          <Route
            path='w2-order-shipping'
            element={<MasterListPage masterType={MasterType.W2_ORDER_SHIPPING} />}
          />
          <Route
            path='w2-order-shipping/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER_SHIPPING} />}
          />
          <Route
            path='w2-order-shipping/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ORDER_SHIPPING} />}
          />
          <Route
            path='w2-shop-shipping'
            element={<MasterListPage masterType={MasterType.W2_SHOP_SHIPPING} />}
          />
          <Route
            path='w2-shop-shipping/new'
            element={<MasterEditPage masterType={MasterType.W2_SHOP_SHIPPING} />}
          />
          <Route
            path='w2-shop-shipping/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_SHOP_SHIPPING} />}
          />
          <Route
            path='w2-shop-shipping-zone'
            element={<MasterListPage masterType={MasterType.W2_SHOP_SHIPPING_ZONE} />}
          />
          <Route
            path='w2-shop-shipping-zone/new'
            element={<MasterEditPage masterType={MasterType.W2_SHOP_SHIPPING_ZONE} />}
          />
          <Route
            path='w2-shop-shipping-zone/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_SHOP_SHIPPING_ZONE} />}
          />
          <Route
            path='w2-shop-shipping-size-threshold'
            element={<MasterListPage masterType={MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD} />}
          />
          <Route
            path='w2-shop-shipping-size-threshold/new'
            element={<MasterEditPage masterType={MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD} />}
          />
          <Route
            path='w2-shop-shipping-size-threshold/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD} />}
          />
          <Route
            path='w2-mail-dist-setting'
            element={<MasterListPage masterType={MasterType.W2_MAIL_DIST_SETTING} />}
          />
          <Route
            path='w2-mail-dist-setting/new'
            element={<MasterEditPage masterType={MasterType.W2_MAIL_DIST_SETTING} />}
          />
          <Route
            path='w2-mail-dist-setting/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MAIL_DIST_SETTING} />}
          />
          <Route
            path='w2-mail-dist-sent-user'
            element={<MasterListPage masterType={MasterType.W2_MAIL_DIST_SENT_USER} />}
          />
          <Route
            path='w2-mail-dist-sent-user/new'
            element={<MasterEditPage masterType={MasterType.W2_MAIL_DIST_SENT_USER} />}
          />
          <Route
            path='w2-mail-dist-sent-user/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MAIL_DIST_SENT_USER} />}
          />
          <Route
            path='w2-mail-send-log'
            element={<MasterListPage masterType={MasterType.W2_MAIL_SEND_LOG} />}
          />
          <Route
            path='w2-mail-send-log/new'
            element={<MasterEditPage masterType={MasterType.W2_MAIL_SEND_LOG} />}
          />
          <Route
            path='w2-mail-send-log/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MAIL_SEND_LOG} />}
          />
          <Route
            path='w2-mail-click'
            element={<MasterListPage masterType={MasterType.W2_MAIL_CLICK} />}
          />
          <Route
            path='w2-mail-click/new'
            element={<MasterEditPage masterType={MasterType.W2_MAIL_CLICK} />}
          />
          <Route
            path='w2-mail-click/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MAIL_CLICK} />}
          />
          <Route
            path='w2-mail-click-log'
            element={<MasterListPage masterType={MasterType.W2_MAIL_CLICK_LOG} />}
          />
          <Route
            path='w2-mail-click-log/new'
            element={<MasterEditPage masterType={MasterType.W2_MAIL_CLICK_LOG} />}
          />
          <Route
            path='w2-mail-click-log/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_MAIL_CLICK_LOG} />}
          />
          <Route
            path='w2-order-workflow-scenario-setting'
            element={<MasterListPage masterType={MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING} />}
          />
          <Route
            path='w2-order-workflow-scenario-setting/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING} />}
          />
          <Route
            path='w2-order-workflow-scenario-setting/edit/:id'
            element={
              <MasterUpdatePage masterType={MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING} />
            }
          />
          <Route
            path='w2-novelty'
            element={<MasterListPage masterType={MasterType.W2_NOVELTY} />}
          />
          <Route
            path='w2-novelty/new'
            element={<MasterEditPage masterType={MasterType.W2_NOVELTY} />}
          />
          <Route
            path='w2-novelty/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_NOVELTY} />}
          />
          <Route
            path='w2-novelty-grant-conditions'
            element={<MasterListPage masterType={MasterType.W2_NOVELTY_GRANT_CONDITIONS} />}
          />
          <Route
            path='w2-novelty-grant-conditions/new'
            element={<MasterEditPage masterType={MasterType.W2_NOVELTY_GRANT_CONDITIONS} />}
          />
          <Route
            path='w2-novelty-grant-conditions/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_NOVELTY_GRANT_CONDITIONS} />}
          />
          <Route
            path='w2-novelty-grant-item'
            element={<MasterListPage masterType={MasterType.W2_NOVELTY_GRANT_ITEM} />}
          />
          <Route
            path='w2-novelty-grant-item/new'
            element={<MasterEditPage masterType={MasterType.W2_NOVELTY_GRANT_ITEM} />}
          />
          <Route
            path='w2-novelty-grant-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_NOVELTY_GRANT_ITEM} />}
          />
          <Route
            path='w2-novelty-target-item'
            element={<MasterListPage masterType={MasterType.W2_NOVELTY_TARGET_ITEM} />}
          />
          <Route
            path='w2-novelty-target-item/new'
            element={<MasterEditPage masterType={MasterType.W2_NOVELTY_TARGET_ITEM} />}
          />
          <Route
            path='w2-novelty-target-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_NOVELTY_TARGET_ITEM} />}
          />
          <Route
            path='w2-order-setpromotion'
            element={<MasterListPage masterType={MasterType.W2_ORDER_SET_PROMOTION} />}
          />
          <Route
            path='w2-order-setpromotion/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER_SET_PROMOTION} />}
          />
          <Route
            path='w2-order-setpromotion/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ORDER_SET_PROMOTION} />}
          />
          <Route
            path='w2-order-setpromotion-item'
            element={<MasterListPage masterType={MasterType.W2_ORDER_SET_PROMOTION_ITEM} />}
          />
          <Route
            path='w2-order-setpromotion-item/new'
            element={<MasterEditPage masterType={MasterType.W2_ORDER_SET_PROMOTION_ITEM} />}
          />
          <Route
            path='w2-order-setpromotion-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ORDER_SET_PROMOTION_ITEM} />}
          />
          <Route
            path='w2-setpromotion'
            element={<MasterListPage masterType={MasterType.W2_SET_PROMOTION} />}
          />
          <Route
            path='w2-setpromotion/new'
            element={<MasterEditPage masterType={MasterType.W2_SET_PROMOTION} />}
          />
          <Route
            path='w2-setpromotion/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_SET_PROMOTION} />}
          />
          <Route
            path='w2-setpromotion-item'
            element={<MasterListPage masterType={MasterType.W2_SET_PROMOTION_ITEM} />}
          />
          <Route
            path='w2-setpromotion-item/new'
            element={<MasterEditPage masterType={MasterType.W2_SET_PROMOTION_ITEM} />}
          />
          <Route
            path='w2-setpromotion-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_SET_PROMOTION_ITEM} />}
          />
          <Route
            path='w2-product-bundle'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_BUNDLE} />}
          />
          <Route
            path='w2-product-bundle/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_BUNDLE} />}
          />
          <Route
            path='w2-product-bundle/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_BUNDLE} />}
          />
          <Route
            path='w2-product-bundle-item'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_BUNDLE_ITEM} />}
          />
          <Route
            path='w2-product-bundle-item/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_BUNDLE_ITEM} />}
          />
          <Route
            path='w2-product-bundle-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_BUNDLE_ITEM} />}
          />
          <Route
            path='w2-product-set'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_SET} />}
          />
          <Route
            path='w2-product-set/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_SET} />}
          />
          <Route
            path='w2-product-set/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_SET} />}
          />
          <Route
            path='w2-product-set-item'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_SET_ITEM} />}
          />
          <Route
            path='w2-product-set-item/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_SET_ITEM} />}
          />
          <Route
            path='w2-product-set-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_SET_ITEM} />}
          />
          <Route
            path='w2-product-sale'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_SALE} />}
          />
          <Route
            path='w2-product-sale/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_SALE} />}
          />
          <Route
            path='w2-product-sale/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_SALE} />}
          />
          <Route
            path='w2-product-sale-price'
            element={<MasterListPage masterType={MasterType.W2_PRODUCT_SALE_PRICE} />}
          />
          <Route
            path='w2-product-sale-price/new'
            element={<MasterEditPage masterType={MasterType.W2_PRODUCT_SALE_PRICE} />}
          />
          <Route
            path='w2-product-sale-price/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PRODUCT_SALE_PRICE} />}
          />
          <Route
            path='w2-fixed-purchase'
            element={<MasterListPage masterType={MasterType.W2_FIXED_PURCHASE} />}
          />
          <Route
            path='w2-fixed-purchase/new'
            element={<MasterEditPage masterType={MasterType.W2_FIXED_PURCHASE} />}
          />
          <Route
            path='w2-fixed-purchase/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FIXED_PURCHASE} />}
          />
          <Route
            path='w2-fixed-purchase-item'
            element={<MasterListPage masterType={MasterType.W2_FIXED_PURCHASE_ITEM} />}
          />
          <Route
            path='w2-fixed-purchase-item/new'
            element={<MasterEditPage masterType={MasterType.W2_FIXED_PURCHASE_ITEM} />}
          />
          <Route
            path='w2-fixed-purchase-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FIXED_PURCHASE_ITEM} />}
          />
          <Route
            path='w2-fixed-purchase-history'
            element={<MasterListPage masterType={MasterType.W2_FIXED_PURCHASE_HISTORY} />}
          />
          <Route
            path='w2-fixed-purchase-history/new'
            element={<MasterEditPage masterType={MasterType.W2_FIXED_PURCHASE_HISTORY} />}
          />
          <Route
            path='w2-fixed-purchase-history/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FIXED_PURCHASE_HISTORY} />}
          />
          <Route
            path='w2-fixed-purchase-cancel-reason'
            element={<MasterListPage masterType={MasterType.W2_FIXED_PURCHASE_CANCEL_REASON} />}
          />
          <Route
            path='w2-fixed-purchase-cancel-reason/new'
            element={<MasterEditPage masterType={MasterType.W2_FIXED_PURCHASE_CANCEL_REASON} />}
          />
          <Route
            path='w2-fixed-purchase-cancel-reason/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FIXED_PURCHASE_CANCEL_REASON} />}
          />
          <Route
            path='w2-user-coupon'
            element={<MasterListPage masterType={MasterType.W2_USER_COUPON} />}
          />
          <Route
            path='w2-user-coupon/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_COUPON} />}
          />
          <Route
            path='w2-user-coupon/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_COUPON} />}
          />
          <Route
            path='w2-user-coupon-history'
            element={<MasterListPage masterType={MasterType.W2_USER_COUPON_HISTORY} />}
          />
          <Route
            path='w2-user-coupon-history/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_COUPON_HISTORY} />}
          />
          <Route
            path='w2-user-coupon-history/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_COUPON_HISTORY} />}
          />
          <Route
            path='w2-coupon-use-user'
            element={<MasterListPage masterType={MasterType.W2_COUPON_USE_USER} />}
          />
          <Route
            path='w2-coupon-use-user/new'
            element={<MasterEditPage masterType={MasterType.W2_COUPON_USE_USER} />}
          />
          <Route
            path='w2-coupon-use-user/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_COUPON_USE_USER} />}
          />
          <Route
            path='w2-coupon-schedule'
            element={<MasterListPage masterType={MasterType.W2_COUPON_SCHEDULE} />}
          />
          <Route
            path='w2-coupon-schedule/new'
            element={<MasterEditPage masterType={MasterType.W2_COUPON_SCHEDULE} />}
          />
          <Route
            path='w2-coupon-schedule/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_COUPON_SCHEDULE} />}
          />
          <Route
            path='w2-advcode-log'
            element={<MasterListPage masterType={MasterType.W2_ADV_CODE_LOG} />}
          />
          <Route
            path='w2-advcode-log/new'
            element={<MasterEditPage masterType={MasterType.W2_ADV_CODE_LOG} />}
          />
          <Route
            path='w2-advcode-log/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ADV_CODE_LOG} />}
          />
          <Route
            path='w2-advcode-media-type'
            element={<MasterListPage masterType={MasterType.W2_ADV_CODE_MEDIA_TYPE} />}
          />
          <Route
            path='w2-advcode-media-type/new'
            element={<MasterEditPage masterType={MasterType.W2_ADV_CODE_MEDIA_TYPE} />}
          />
          <Route
            path='w2-advcode-media-type/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_ADV_CODE_MEDIA_TYPE} />}
          />
          <Route
            path='w2-user-activity'
            element={<MasterListPage masterType={MasterType.W2_USER_ACTIVITY} />}
          />
          <Route
            path='w2-user-activity/new'
            element={<MasterEditPage masterType={MasterType.W2_USER_ACTIVITY} />}
          />
          <Route
            path='w2-user-activity/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_USER_ACTIVITY} />}
          />
          <Route
            path='w2-ab-test'
            element={<MasterListPage masterType={MasterType.W2_AB_TEST} />}
          />
          <Route
            path='w2-ab-test/new'
            element={<MasterEditPage masterType={MasterType.W2_AB_TEST} />}
          />
          <Route
            path='w2-ab-test/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_AB_TEST} />}
          />
          <Route
            path='w2-ab-test-item'
            element={<MasterListPage masterType={MasterType.W2_AB_TEST_ITEM} />}
          />
          <Route
            path='w2-ab-test-item/new'
            element={<MasterEditPage masterType={MasterType.W2_AB_TEST_ITEM} />}
          />
          <Route
            path='w2-ab-test-item/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_AB_TEST_ITEM} />}
          />
          {/* W2 CMS系マスタ（add-w2-cms-master-tables で追加） */}
          <Route
            path='w2-page-design'
            element={<MasterListPage masterType={MasterType.W2_PAGE_DESIGN} />}
          />
          <Route
            path='w2-page-design/new'
            element={<MasterEditPage masterType={MasterType.W2_PAGE_DESIGN} />}
          />
          <Route
            path='w2-page-design/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PAGE_DESIGN} />}
          />
          <Route
            path='w2-page-design-group'
            element={<MasterListPage masterType={MasterType.W2_PAGE_DESIGN_GROUP} />}
          />
          <Route
            path='w2-page-design-group/new'
            element={<MasterEditPage masterType={MasterType.W2_PAGE_DESIGN_GROUP} />}
          />
          <Route
            path='w2-page-design-group/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PAGE_DESIGN_GROUP} />}
          />
          <Route
            path='w2-parts-design'
            element={<MasterListPage masterType={MasterType.W2_PARTS_DESIGN} />}
          />
          <Route
            path='w2-parts-design/new'
            element={<MasterEditPage masterType={MasterType.W2_PARTS_DESIGN} />}
          />
          <Route
            path='w2-parts-design/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PARTS_DESIGN} />}
          />
          <Route
            path='w2-parts-design-group'
            element={<MasterListPage masterType={MasterType.W2_PARTS_DESIGN_GROUP} />}
          />
          <Route
            path='w2-parts-design-group/new'
            element={<MasterEditPage masterType={MasterType.W2_PARTS_DESIGN_GROUP} />}
          />
          <Route
            path='w2-parts-design-group/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_PARTS_DESIGN_GROUP} />}
          />
          <Route
            path='w2-feature-area'
            element={<MasterListPage masterType={MasterType.W2_FEATURE_AREA} />}
          />
          <Route
            path='w2-feature-area/new'
            element={<MasterEditPage masterType={MasterType.W2_FEATURE_AREA} />}
          />
          <Route
            path='w2-feature-area/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FEATURE_AREA} />}
          />
          <Route
            path='w2-feature-area-banner'
            element={<MasterListPage masterType={MasterType.W2_FEATURE_AREA_BANNER} />}
          />
          <Route
            path='w2-feature-area-banner/new'
            element={<MasterEditPage masterType={MasterType.W2_FEATURE_AREA_BANNER} />}
          />
          <Route
            path='w2-feature-area-banner/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_FEATURE_AREA_BANNER} />}
          />
          <Route path='w2-popup' element={<MasterListPage masterType={MasterType.W2_POPUP} />} />
          <Route
            path='w2-popup/new'
            element={<MasterEditPage masterType={MasterType.W2_POPUP} />}
          />
          <Route
            path='w2-popup/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_POPUP} />}
          />
          <Route
            path='w2-popup-display-page-setting'
            element={<MasterListPage masterType={MasterType.W2_POPUP_DISPLAY_PAGE_SETTING} />}
          />
          <Route
            path='w2-popup-display-page-setting/new'
            element={<MasterEditPage masterType={MasterType.W2_POPUP_DISPLAY_PAGE_SETTING} />}
          />
          <Route
            path='w2-popup-display-page-setting/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_POPUP_DISPLAY_PAGE_SETTING} />}
          />
          <Route
            path='w2-popup-report'
            element={<MasterListPage masterType={MasterType.W2_POPUP_REPORT} />}
          />
          <Route
            path='w2-popup-report/new'
            element={<MasterEditPage masterType={MasterType.W2_POPUP_REPORT} />}
          />
          <Route
            path='w2-popup-report/edit/:id'
            element={<MasterUpdatePage masterType={MasterType.W2_POPUP_REPORT} />}
          />
          <Route path='file-upload' element={<FileUploadPage />} />
          {/* Recommend engine */}
          <Route path='recommend/dashboard' element={<SiteDashboardPage />} />
          <Route path='recommend/dashboard/delivery-stats' element={<DeliveryStatsPage />} />
          <Route path='recommend/order-history' element={<OrderHistoryPage />} />
          <Route path='recommend/behavior' element={<BehaviorListPage />} />
          <Route path='recommend/customers' element={<AccessCustomerListPage />} />
          <Route path='recommend/model-tuning' element={<ModelTuningPage />} />
          <Route path='recommend/widgets' element={<WidgetListPage />} />
          <Route path='recommend/widgets/new' element={<WidgetEditPage />} />
          <Route path='recommend/widgets/edit/:widgetId' element={<WidgetUpdatePage />} />
          <Route path='recommend/widget-pages' element={<WidgetPageListPage />} />
          <Route path='recommend/widget-pages/new' element={<WidgetPageEditPage />} />
          <Route
            path='recommend/widget-pages/:widgetPageId/edit'
            element={<WidgetPageUpdatePage />}
          />
          <Route path='recommend/distributions' element={<RecommendationDistributionListPage />} />
          <Route
            path='recommend/distributions/new'
            element={<RecommendationDistributionEditPage />}
          />
          <Route
            path='recommend/distributions/:distributionId/edit'
            element={<RecommendationDistributionUpdatePage />}
          />
          <Route
            path='recommend/distributions/:distributionId/ab-campaign'
            element={<RecommendationDistributionAbCampaignPage />}
          />
          <Route path='recommend/tags' element={<TagManagerPage />} />
          <Route path='recommend/ai-tags' element={<AITagListPage />} />
          <Route path='recommend/ai-tags/new' element={<TagEditPage />} />
          <Route path='recommend/ai-tags/edit/:tagId' element={<TagUpdatePage />} />
          <Route path='recommend/setup-guide' element={<SetupGuidePage />} />

          {/* サイト設定 — オペレーター管理 */}
          <Route path='settings/operators' element={<SiteOperatorListPage />} />
          <Route path='settings/operators/new' element={<SiteOperatorEditPage />} />
          <Route path='settings/operators/:operatorId/edit' element={<SiteOperatorUpdatePage />} />

          {/* サイト設定 — 権限管理 */}
          <Route path='settings/permissions' element={<PermissionTemplateListPage />} />
          <Route path='settings/permissions/new' element={<PermissionTemplateEditPage />} />
          <Route
            path='settings/permissions/:permissionId/edit'
            element={<PermissionTemplateUpdatePage />}
          />

          {/* Media Driver */}
          <Route path='media/dashboard' element={<MediaDashboardPage />} />
          <Route path='media/action' element={<MediaActionPage />} />
          <Route path='media/analysis-automation' element={<MediaAnalysisAutomationPage />} />
          <Route path='media/analysis-target' element={<AnalysisTargetListPage />} />
          <Route path='media/analysis-target/new' element={<AnalysisTargetEditPage />} />
          <Route
            path='media/analysis-target/:targetId/edit'
            element={<AnalysisTargetUpdatePage />}
          />
          {/* AI学習用データ（media-ai-training-data） */}
          <Route path='media/ai-training-data' element={<MediaAiTrainingDataPage />} />
          <Route
            path='media/ai-training-data/article-html'
            element={<MediaAiTrainingDataArticleHtmlPage />}
          />
          <Route
            path='media/ai-training-data/common-rules'
            element={<MediaAiTrainingDataCommonRulesPage />}
          />
          {/* 記事管理（media-article） */}
          <Route path='media/articles' element={<ArticleListPage />} />
          <Route path='media/articles/new' element={<ArticleEditPage />} />
          <Route path='media/articles/analysis' element={<ArticleAnalysisListPage />} />
          <Route path='media/articles/uploads' element={<ArticleApprovalListPage />} />
          <Route path='media/articles/uploads/:requestId' element={<ArticleApprovalDetailPage />} />
          <Route path='media/articles/:articleId' element={<ArticleDetailPage />} />
          <Route path='media/articles/:articleId/edit' element={<ArticleUpdatePage />} />
          {/* サイト現状分析（media-analysis） */}
          <Route path='media/analysis' element={<MediaAnalysisPage />} />
          <Route path='media/analysis/history' element={<MediaAnalysisHistoryPage />} />
          <Route
            path='media/analysis/competitor/:historyId/result'
            element={<MediaAnalysisCompetitorResultPage />}
          />
          <Route
            path='media/analysis/serp/:historyId/result'
            element={<MediaAnalysisSerpResultPage />}
          />
          <Route
            path='media/analysis/gap/:historyId/result'
            element={<MediaAnalysisGapResultPage />}
          />
          <Route
            path='media/analysis/cannibalization/:historyId/result'
            element={<MediaAnalysisCannibalizationResultPage />}
          />
          <Route
            path='media/analysis/link-structure/:historyId/result'
            element={<MediaAnalysisLinkStructureResultPage />}
          />
          <Route
            path='media/analysis/citation/:historyId/result'
            element={<MediaAnalysisCitationResultPage />}
          />
          <Route
            path='media/analysis/share-of-voice/:historyId/result'
            element={<MediaAnalysisShareOfVoiceResultPage />}
          />
          <Route
            path='media/analysis/sentiment/:historyId/result'
            element={<MediaAnalysisSentimentResultPage />}
          />
          <Route
            path='media/analysis/query-fanout/:historyId/result'
            element={<MediaAnalysisQueryFanoutResultPage />}
          />
          <Route path='media/gsc-linkage' element={<MediaGscLinkagePage />} />
          {/* UGC Intelligence */}
          <Route path='ugc-dashboard' element={<UGCFunnelDashboardPage />} />
          {/* 旧「今後追加される機能」。内容は設定ガイドの末尾に統合したので転送する */}
          <Route path='ugc-roadmap' element={<Navigate to='../ugc-guide' replace />} />
          <Route path='ugc-guide' element={<UGCGuide />} />
          <Route path='ugc-reviews' element={<UGCReviewManagement />} />
          <Route path='ugc-instagram' element={<UGCInstagramCollection />} />
          <Route path='ugc-instagram-settings' element={<UGCInstagramSettingsPage />} />
          {/* 旧「レビュー依頼配信設定」。5タブすべて［レビュー依頼メール］へ移設済み。
              ブックマークが404にならないようリダイレクトする */}
          <Route path='ugc-requests' element={<Navigate to='../ugc-mail' replace />} />
          <Route path='ugc-mail' element={<UGCMailPage />} />
          <Route path='ugc-ai-score' element={<UGCAIScoreSettings />} />
          <Route path='ugc-display-rules' element={<UGCDisplayRules />} />
          <Route path='ugc-display-rules/new' element={<UGCDisplayRuleEdit />} />
          <Route path='ugc-display-rules/edit/:ruleId' element={<UGCDisplayRuleEdit />} />
          <Route path='ugc-product-tagging' element={<UGCProductTagging />} />
          <Route path='ugc-seo' element={<UGCSEODashboard />} />
          <Route path='ugc-tag-embed' element={<UGCTagEmbed />} />
          <Route path='ugc-cvr' element={<UGCCVRDashboard />} />
          <Route path='ugc-voc' element={<UGCVOCAnalysis />} />
          <Route path='ugc-wear' element={<UGCWearDetection />} />
          {/* 準備中の機能。説明は設定ガイド末尾の「今後追加される機能」にある */}
          <Route path='ugc-gifting' element={<Navigate to='../ugc-guide' replace />} />
          {/* 旧「SNS連携」「API連携設定」。Instagram設定に統合したので転送する
              （ブックマーク・画面内リンクからの流入を切らないため） */}
          <Route path='ugc-brand' element={<Navigate to='../ugc-instagram-settings' replace />} />
          <Route
            path='ugc-api-keys'
            element={<Navigate to='../ugc-instagram-settings' replace />}
          />
          <Route path='ugc-staff' element={<Navigate to='../ugc-guide' replace />} />
          <Route path='ugc-qa' element={<Navigate to='../ugc-guide' replace />} />
          <Route path='ugc-video' element={<Navigate to='../ugc-guide' replace />} />
          {/* 媒体別KPIレポートはCVRダッシュボードへ統合（データ源がほぼ同じだった） */}
          <Route path='ugc-ad-kpi' element={<Navigate to='../ugc-cvr' replace />} />
          <Route path='ugc-omo' element={<Navigate to='../ugc-guide' replace />} />
          <Route path='ugc-compliance' element={<UGCDeletionRequestPage />} />
          <Route path='ugc-portal' element={<Navigate to='../ugc-guide' replace />} />
          {/* Ai purchase assist */}
          <Route path='ai-purchase-assist' element={<AIPurchaseAssistDashboard />} />
          <Route path='ai-purchase-assist/campaigns' element={<AIPurchaseAssistCampaigns />} />
          <Route path='ai-purchase-assist/ab-tests' element={<AIPurchaseAssistAbTests />} />
          <Route
            path='ai-purchase-assist/conversations'
            element={<AIPurchaseAssistConversations />}
          />
          <Route path='ai-purchase-assist/ai-profiles' element={<AIPurchaseAssistAiProfiles />} />
          <Route path='ai-purchase-assist/ng-rules' element={<AIPurchaseAssistNgRules />} />
          <Route
            path='ai-purchase-assist/vector-sources'
            element={<AIPurchaseAssistVectorSources />}
          />
          <Route path='ai-purchase-assist/feedback' element={<AIPurchaseAssistFeedback />} />
          <Route path='ai-purchase-assist/knowledge' element={<AIPurchaseAssistKnowledge />} />
          <Route path='ai-purchase-assist/openings' element={<AIPurchaseAssistOpenings />} />
          <Route path='ai-purchase-assist/rich-ui' element={<AIPurchaseAssistRichUIDesigner />} />
          {/* Search suggest (Findee) */}
          <Route
            path='search-suggest'
            element={<Navigate to='search-suggest/settings' replace />}
          />
          <Route path='search-suggest/settings' element={<SearchSuggestSettingsPage />} />
          {/* 配信設定は「設定」へ統合済み（旧URLはリダイレクト） */}
          <Route
            path='search-suggest/delivery'
            element={<Navigate to='search-suggest/settings' replace />}
          />
          <Route path='search-suggest/dictionary' element={<SearchSuggestDictionaryPage />} />
          <Route path='search-suggest/analytics' element={<SearchSuggestAnalyticsPage />} />
          {/* Tag Trail（Phase 3a）。既定はダッシュボード */}
          <Route path='search-tags' element={<Navigate to='search-tags/dashboard' replace />} />
          <Route path='search-tags/dashboard' element={<SearchTagDashboardPage />} />
          <Route path='search-tags/candidates' element={<SearchTagCandidatesPage />} />
          <Route path='search-tags/tags' element={<SearchTagListPage />} />
          <Route path='search-tags/optimizations' element={<SearchTagOptimizationsPage />} />
          <Route path='search-tags/delivery' element={<SearchTagDeliveryPage />} />
          <Route path='search-tags/settings' element={<SearchTagSettingsPage />} />
          {/* Data analytics */}
          <Route
            path='journey'
            element={
              <TempPrePageMain>
                <CustomerJourney />
              </TempPrePageMain>
            }
          />
          {/* Admin & Operator common */}
          <Route
            path='site-operators'
            element={
              <TempPrePageMain>
                <SiteOperatorManagement />
              </TempPrePageMain>
            }
          />
          <Route
            path='permissions'
            element={
              <TempPrePageMain>
                <PermissionManagement />
              </TempPrePageMain>
            }
          />
          <Route
            path='password-change'
            element={
              <TempPrePageMain>
                <PasswordChange />
              </TempPrePageMain>
            }
          />
        </Route>
        {!isMeLoading && operatorMe && (
          <Route path='*' element={<Navigate to={defaultRedirect} replace />} />
        )}
      </SentryRoutes>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <AuthProvider>
          <AppHeaderProvider>
            <AppContent />
          </AppHeaderProvider>
        </AuthProvider>
      </AppProvider>
    </BrowserRouter>
  )
}
